<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<div slot="header"><i class="icon-layers"></i> Office Modules</div>
					<div class="d-flex flex-row mb-5">
						<div class="col-2">
							Select Office
						</div>
						<div class="col-6">
							<multiselect @input="getEmployeeList()" v-model="selectedOffice"
													 :options="officeList"
													 :close-on-select="false"
													 :searchable="true"
													 label = "name"
													 placeholder="Pick a value"></multiselect>
						</div>
					</div>
					<div class="d-flex flex-row mb-5">
						<div class="col-2">
							Parking Operations Manager
						</div>
						<div class="col-6">
							<multiselect @input="getEmployeeList()" v-model="selectedEmployee"
													 :options="employeeList"
													 :close-on-select="false"
													 :searchable="true"
													 label = "name"
													 placeholder="Pick a value"></multiselect>
						</div>
						<div class="col-4" v-if="$store.getters.canWrite">
							<b-button variant="success" @click="setEmployeeRole()"><i
								class="fa fa-save"></i> Save
							</b-button>
						</div>
					</div>
					<div class="d-flex flex-row mb-5">
						<div class="col-2">
							Generate Dummy Data
						</div>
						<div class="col-6">
							<b-button variant="success" @click="generateParkingDummyData()"><i
								class="fa-solid fa-engine"></i> Generate Dummy Data
							</b-button>
						</div>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import generalSettingsService from "@/services/generalSettingsService";
	import Multiselect from 'vue-multiselect'

	export default {
		name: "ParkingManagementGeneralSettings",
		components : {
			Multiselect
		},
		data : function () {
			return {
				officeList: [],
				employeeList : [],
				selectedOffice: null,
				selectedEmployee : "",
			}
		},

		methods : {
			getEmployeeList(){
				officeService.getEmployeeList(this.selectedOffice.id, r =>{
						this.employeeList = r;
						// console.log(r);
					}, e => toastService.showErrorToast(e)
				);
			},
			setEmployeeRole(){
				const request = {
					officeId : this.selectedOffice.id,
					employeeRole : "PARKING_OPERATIONS_MANAGER"
				}
				let	employeeId = this.selectedEmployee.id;

				officeService.setEmployeeRole(employeeId, request, r =>{
						toastService.showSuccessToast("Update Successful");
					},e =>toastService.showErrorToast(e)
				);
			},

			generateParkingDummyData(){
				generalSettingsService.generateParkingDummyData(r =>{
						toastService.showSuccessToast("Data Generation Successful");
					},e =>toastService.showErrorToast(e)
				);
			},
		},
		mounted() {
			officeService.getOfficeList( r => {
				this.officeList = r;
			});
		}

	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

